import { NegativeColors } from '@picsart/design-system/foundation/colors';

import { createUseStyles } from 'react-jss';

import { Spacings } from '@picsart/design-system/foundation/spacings';
// import { OldBreakPoints } from '@picsart/rc/enums';

const useStyles = createUseStyles<string, { titleColor?: string }>(
  {
    root: {
      height: 'fit-content',
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      backgroundImage:
        'linear-gradient(-46deg, #19D7E7 -7.24%, #7F4AD9 45.81%, #A82BCE 70.83%, #DF02C0 100%)',
    },
    content: {
      display: 'grid',
      gridTemplateColumns: '3fr 1fr',
      justifyContent: 'center',
      alignItems: 'start',
      paddingBlock: Spacings.s72,

      // [mediaQuery(OldBreakPoints.large)]: {
      '@media screen and (max-width: 1281px)': {
        gap: Spacings.s48,
      },

      // [mediaQuery(OldBreakPoints.medium)]: {
      '@media screen and (max-width: 1024px)': {
        gridTemplateColumns: '1fr',
      },
    },

    titleWithBullets: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      gap: Spacings.s72,

      // [mediaQuery(OldBreakPoints.large)]: {
      '@media screen and (max-width: 1281px)': {
        gap: Spacings.s32,
      },
    },
    bullets: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: Spacings.s16,
    },
    title: {
      color: NegativeColors.text.default,
      '& i': {
        color: ({ titleColor }) => titleColor || '#72FFEA',
        fontStyle: 'normal',
      },
    },
    button: {
      width: '100%',
      maxWidth: 260,
      marginTop: Spacings.s8,
      justifySelf: 'end',

      // [mediaQuery(OldBreakPoints.medium)]: {
      '@media screen and (max-width: 1024px)': {
        maxWidth: '100%',
      },
    },
    // Skeleton
    sectionSkeleton: {
      width: '100%',
      height: 360,
    },
  },
  {
    name: 'start-for-free',
  },
);

export default useStyles;
